module.exports = __webpack_public_path__ + "static/unnecessary-belongings_ceramic_silver_found-object_metal-thread-8d5f51cd58f347f8b747dfe61512f59a.jpg";